/* sts-product.js notes: docs/new-theme-v4/asset-notes/sts-product-js.md */
(function () {
  'use strict';

  if (document.querySelector('[data-sts-plans]') && !document.querySelector('.sts-sub__slot')) {
    window.DISABLE_RECHARGE = true;
  }

  /* One place decides which backend we talk to: snippets/sts-env.liquid
     resolves the sts.api_env / sts.*_base_* shop metafields and publishes
     window.STS.env. The value rendered into the data attribute stays as the
     fallback; going through env is also what applies the "dev never runs on
     the published theme" refusal. */
  function envBase(key, fallback, hard) {
    var E = window.STS && window.STS.env;
    return String((E && E.get) ? E.get(key, fallback || hard) : (fallback || hard));
  }

  var TYPES = ['DSPT', 'DSNT', 'DSPW', 'DSNW', 'OSPT', 'OSNT', 'OSPW', 'OSNW',
    'ORPT', 'ORNT', 'ORPW', 'ORNW', 'DRPT', 'DRNT', 'DRPW', 'DRNW'];
  var FLIP ={ D: 'O', O: 'D', S: 'R', R: 'S', P: 'N', N: 'P', W: 'T', T: 'W' };
  var SUBTYPE_NAMES = { S1: 'Acne', S2: 'Redness', S3: 'Stinging', S4: 'Allergic' };

  // ------------------------------------------------------------------ helpers

  function qs(root, sel) { return root.querySelector(sel); }
  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function on(el, ev, fn) { if (el) el.addEventListener(ev, fn); }
  /* `scroll-behavior: auto !important` in CSS does NOT override a behaviour
     passed to scrollTo(), so the gallery has to ask the query itself. */
  function scrollBehavior() {
    try {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ? 'auto' : 'smooth';
    } catch (e) { return 'smooth'; }
  }
  function text(el, value) { if (el) el.textContent = value; }
  function show(el, visible) { if (el) el.hidden = !visible; }

  var NET_TIMEOUT_MS = 8000;

  function netFetch(url, opts, ms) {
    var limit = ms || NET_TIMEOUT_MS;
    var ctrl = typeof window.AbortController === 'function' ? new window.AbortController() : null;
    var o = {};
    var k;
    for (k in (opts || {})) { if (Object.prototype.hasOwnProperty.call(opts, k)) o[k] = opts[k]; }
    if (ctrl) o.signal = ctrl.signal;
    var timer = window.setTimeout(function () {
      if (ctrl) { try { ctrl.abort(); } catch (e) { /* already gone */ } }
    }, limit);
    /* Plain window.fetch on purpose: shop_events_listener wraps it, and that
       is the only source of product_added_to_cart. See layout/theme.liquid. */
    var req = window.fetch(url, o);
    /* No AbortController (very old engines): the race still rejects on time, so
       the caller is never left waiting even though the socket stays open. */
    var race = ctrl ? req : Promise.race([req, new Promise(function (_, reject) {
      window.setTimeout(function () { reject(new Error('timeout')); }, limit);
    })]);
    return race.then(
      function (r) { window.clearTimeout(timer); return r; },
      function (e) {
        window.clearTimeout(timer);
        /* An abort reads as "Failed to fetch" otherwise, which callers surface
           to the shopper. Say what actually happened. */
        throw (e && e.name === 'AbortError') ? new Error('timeout') : e;
      }
    );
  }

  function readLocal(key) {
    try { return window.localStorage.getItem(key); } catch (e) { return null; }
  }
  function parse(raw) {
    try { return JSON.parse(raw); } catch (e) { return null; }
  }

  function state() {
    return (window.STS && window.STS.state) || { type: null, loggedIn: false, typed: false };
  }

  function jsonFrom(root, selector) {
    var node = qs(root, selector);
    if (!node) return null;
    return parse(node.textContent);
  }

  /* The type the page was PAINTED with. html[data-sts-type] is what
     snippets/sts-pdp-fit.liquid's generated rules key off, so reading it here
     means the reason sentence, the subtype line and the sts_fit_view event can
     never describe a different verdict from the one on screen. It is normally
     the same value as STS.state.type — the head resolver writes both — but the
     staff state simulator applies its state after the head script, and this is
     the half that is already on <html> by first paint either way. */
  function shopperType() {
    var s = state();
    if (s.type && TYPES.indexOf(s.type) > -1) return s.type;
    var painted = document.documentElement.getAttribute('data-sts-type');
    return (painted && TYPES.indexOf(painted) > -1) ? painted : null;
  }

  // ---------------------------------------------------------------- analytics

  /* Spec 09 §6.9. window.stsTrack is the only way this file reaches an
     analytics destination; it owns consent, the ad allow-list and the scrub.
     Analytics is never load bearing, so every call is swallowed. */
  function track(name, params) {
    try { if (typeof window.stsTrack === 'function') window.stsTrack(name, params); } catch (e) { /* never break a page */ }
  }

  /* Events 2, 5 and 6 are one tap seen three ways. STSTrack.quizClick decides
     which, so the fit box classifies a tap exactly as the header and the
     collection lock do. */
  function quizClick(placement, href, kind, quizUrl) {
    try {
      var T = window.STSTrack;
      if (T && typeof T.quizClick === 'function') return T.quizClick(placement, href, kind, quizUrl);
    } catch (e) { /* never break a page */ }
    return false;
  }

  /* Event 35's reason: the HTTP status the fetch rejected with, or the error's
     own short message. Same shape as assets/sts-collection.js. */
  function failReason(err) {
    return typeof err === 'number' ? 'http_' + err : String((err && err.message) || 'fetch').slice(0, 40);
  }

  // ------------------------------------------------------------------ notices

  /* v5.1 §1.5: no toasts. An add confirms itself (the cart count, the button
     label); what the customer must still notice is a popup through the shared
     queue (assets/sts-popups.js). */
  function notice(title, body) {
    var P = window.STS && window.STS.popups;
    if (P && P.notice) P.notice({ title: title, body: body });
  }

  // ------------------------------------------------------------------- dialog

  /* One dialog primitive, used by the Buy-it-anyway confirm. Focus moves in,
     Tab is trapped, Escape closes, focus returns to whatever opened it
     (criterion 58). Workstream 04's collection half ships snippets/sts-modal;
     when it lands this should call that instead of drawing its own. */
  function confirmDialog(opts) {
    return new Promise(function (resolve) {
      var opener = document.activeElement;
      var scrim = document.createElement('div');
      scrim.className = 'sts-dlg-scrim';
      scrim.innerHTML =
        '<div class="sts-dlg" role="dialog" aria-modal="true" aria-labelledby="sts-dlg-t">' +
        '<p class="sts-dlg__title" id="sts-dlg-t"></p>' +
        '<p class="sts-dlg__body"></p>' +
        '<div class="sts-dlg__actions">' +
        '<button type="button" class="sts-btn sts-btn--danger" data-yes></button>' +
        '<button type="button" class="sts-btn sts-btn--ghost" data-no></button>' +
        '</div></div>';
      text(qs(scrim, '.sts-dlg__title'), opts.title);
      text(qs(scrim, '.sts-dlg__body'), opts.body);
      text(qs(scrim, '[data-yes]'), opts.yes);
      text(qs(scrim, '[data-no]'), opts.no);
      document.body.appendChild(scrim);
      /* v6.1 1.2: ! octagon, the reason behind "Note from Dr. Baumann ▾". */
      var P = window.STS && window.STS.popups;
      if (P && P.notFor) P.notFor(qs(scrim, '.sts-dlg__title'), qs(scrim, '.sts-dlg__body'));

      var focusable = qsa(scrim, 'button');
      qs(scrim, '[data-yes]').focus();

      function close(answer) {
        document.removeEventListener('keydown', onKey, true);
        scrim.remove();
        if (opener && opener.focus) opener.focus();
        resolve(answer);
      }
      function onKey(ev) {
        if (ev.key === 'Escape') { ev.preventDefault(); close(false); return; }
        if (ev.key !== 'Tab') return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (ev.shiftKey && document.activeElement === first) { ev.preventDefault(); last.focus(); }
        else if (!ev.shiftKey && document.activeElement === last) { ev.preventDefault(); first.focus(); }
      }
      document.addEventListener('keydown', onKey, true);
      on(qs(scrim, '[data-yes]'), 'click', function () { close(true); });
      on(qs(scrim, '[data-no]'), 'click', function () { close(false); });
      on(scrim, 'click', function (ev) { if (ev.target === scrim) close(false); });
    });
  }

  // --------------------------------------------------------------------- cart

  function cartAdd(items) {
    return netFetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (body) {
        if (!r.ok) {
          var e = new Error((body && (body.description || body.message)) || 'Add to cart failed');
          e.description = body && body.description;  // what STS.shopperError shows
          throw e;
        }
        return body;
      });
    });
  }

  /* `sts:cart:updated` is the theme's canonical "the cart was written" event
     (assets/sts-routine-shared.js names it); `theme:cart:change` is the legacy
     alias the theme's own header count and free-shipping bar listen on
     (assets/theme.js, Totals). Both carry the cart in detail.cart. Firing them
     is the whole integration: this file never touches the header itself.
     Spelled out here rather than called through STSRoutine.cart.notifyChanged
     because sts-routine-shared.js is only on the PDP when FBT is enabled
     (sections/sts-main-product.liquid:100). */
  function announceCart() {
    return netFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return null;
        var detail = { cart: cart };
        document.dispatchEvent(new CustomEvent('sts:cart:updated', { detail: detail }));
        document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: detail }));
        return cart;
      })
      .catch(function () { return null; });
  }

  // ------------------------------------------------------- fit, client side

  /* The same walk snippets/sts-product-fit.liquid does: the first letter of the
     shopper's type that no approved code carries, else the first letter whose
     single axis flip lands on an approved code, else '*'. Kept in step with that
     file — if one changes, change both, or a signed-in and a signed-out shopper
     are given different reasons for the same product. */
  function barredLetter(type, approved) {
    var i;
    var hard = '';
    for (i = 0; i < 4; i++) {
      var letter = type.charAt(i);
      var carried = false;
      for (var j = 0; j < approved.length; j++) {
        if (approved[j].indexOf(letter) > -1) { carried = true; break; }
      }
      if (!carried) hard += letter;
    }
    if (hard) return hard.charAt(0);
    for (i = 0; i < 4; i++) {
      var candidate = type.slice(0, i) + FLIP[type.charAt(i)] + type.slice(i + 1);
      if (approved.indexOf(candidate) > -1) return type.charAt(i);
    }
    return '*';
  }

  function shopperSubtypes() {
    var raw = parse(readLocal('customerSensitivityList'));
    if (!raw) return [];
    var list = Array.isArray(raw) ? raw : String(raw).split(',');
    return list.map(function (s) { return String(s).trim().toUpperCase(); })
      .filter(function (s) { return SUBTYPE_NAMES[s]; });
  }

  /* Runs at boot AND on every STS.onState change; see asset-notes/sts-product-js.md
     ("resolveFit"). data-sts-js is the type JS last resolved for. */
  function resolveFit(root) {
    var type = shopperType();
    var was = root.getAttribute('data-sts-js');
    if (was === (type || null)) return;
    if (!type && was === null) return;
    var approved = (root.getAttribute('data-sts-approved') || '').split(' ').filter(Boolean);
    if (!approved.length) return;

    var slot = qs(root, '[data-sts-own-octagon]');
    if (slot) {
      slot.textContent = '';
      if (type) {
        var oct = document.createElement('span');
        oct.className = 'sts-oct';
        oct.setAttribute('data-sts-type', type);
        oct.setAttribute('role', 'img');
        oct.setAttribute('aria-label', 'Baumann Skin Type ' + (TYPES.indexOf(type) + 1) + ', ' + type);
        oct.textContent = String(TYPES.indexOf(type) + 1);
        slot.appendChild(oct);
      }
    }
    /* Signed in: Liquid already wrote the verdict and the sentence for this type. */
    if (was === null && type === (window.__STS_SERVER__ || {}).type && root.getAttribute('data-sts-fit') !== 'unknown') {
      root.setAttribute('data-sts-js', type);
      return;
    }

    var fit = 'unknown';
    var letter = '';
    var sentence = '';
    var sub = '';
    if (type && approved.indexOf(type) > -1) {
      /* 04-Q7: R1 is never a missing subtype (shopperSubtypes drops it). */
      var carried = (root.getAttribute('data-sts-sens') || '').split(' ').filter(Boolean);
      var missing = shopperSubtypes().filter(function (code) { return carried.indexOf(code) < 0; });
      fit = 'approved';
      if (missing.length) {
        fit = 'subtype';
        sub = 'Not approved for the ' + missing.map(function (code) { return SUBTYPE_NAMES[code]; }).join(', ') + '-prone form of sensitive skin.';
      }
    } else if (type) {
      fit = 'barred';
      letter = barredLetter(type, approved);
      var reasons = jsonFrom(root, '[data-sts-reasons]') || {};
      sentence = reasons[letter] || reasons['*'] || 'Dr. Baumann has not approved this product for your Baumann Skin Type.';
    }

    root.setAttribute('data-sts-fit', fit);
    if (letter) root.setAttribute('data-sts-bar', letter); else root.removeAttribute('data-sts-bar');
    if (sub) root.setAttribute('data-sts-subtype', 'miss'); else root.removeAttribute('data-sts-subtype');
    if (type) root.setAttribute('data-sts-js', type); else root.removeAttribute('data-sts-js');
    var reasonEl = qs(root, '[data-sts-reason]');
    if (reasonEl) reasonEl.textContent = sentence;
    var line = qs(root, '[data-sts-subtype-reason]');
    if (line) { line.textContent = sub; line.hidden = !sub; }
  }

  /* §6.9 event 12, once per page view, AFTER resolveFit — so the verdict
     reported is the one on screen, including the subtype mismatch resolveFit
     resolves for an anonymous typed shopper. A product with no approval list is
     `unknown`, the same answer an untyped visitor gets, because neither of them
     was shown a verdict. */
  function emitFitView(root) {
    var approved = (root.getAttribute('data-sts-approved') || '').split(' ').filter(Boolean);
    var type = shopperType();
    var fit = 'unknown';
    var letter = null;
    if (approved.length && type) {
      if (approved.indexOf(type) < 0) {
        fit = 'wrong';
        letter = barredLetter(type, approved);
      } else {
        fit = root.getAttribute('data-sts-subtype') === 'miss' ? 'wrong' : 'right';
      }
    }
    track('sts_fit_view', {
      fit: fit,
      letter: letter,
      product_id: root.getAttribute('data-product-id')
    });
  }

  /* The fit box is the only quiz call to action on a product page. Placement
     `pdp_box` is the name spec §6.9 event 2 gives it. quizClick returns false
     for a link that does not go to the quiz, so handing it every anchor in the
     box is safe. */
  function initQuizLinks(root) {
    var quizUrl = root.getAttribute('data-quiz-url') || null;
    qsa(root, '.sts-pdp__fitbox a[href]').forEach(function (link) {
      on(link, 'click', function () {
        quizClick('pdp_box', link.getAttribute('href'), null, quizUrl);
      });
    });
  }

  /* The whole rating row is the link (PDP-3). A template without the reviews
     section would leave it pointing nowhere, so it becomes the plain row it
     looks like: same class, same children, no link. */
  function initReviewsLink(root) {
    if (document.getElementById('pdp-reviews')) return;
    qsa(root, 'a.sts-pdp__rating[href="#pdp-reviews"]').forEach(function (link) {
      var row = document.createElement('div');
      row.className = link.className;
      while (link.firstChild) row.appendChild(link.firstChild);
      link.parentNode.replaceChild(row, link);
    });
  }

  /* 04-Q39: some affiliate partners must not see the cash-back line. The code
     lives in localStorage, so the suppression cannot be done in Liquid. */
  function applyCashSuppression(root) {
    var hidden = (root.getAttribute('data-cash-hidden-codes') || '')
      .split(',').map(function (c) { return c.trim().toUpperCase(); }).filter(Boolean);
    if (!hidden.length) return;
    var code = (readLocal('affiliateCode') || '').trim().toUpperCase();
    if (!code || hidden.indexOf(code) < 0) return;
    root.stsCashOff = true;
    qsa(root, '[data-sts-cash-line],[data-sts-sticky-cash]').forEach(function (el) { el.hidden = true; });
  }

  // ----------------------------------------------------------------- variants

  function initVariants(root, ctx) {
    /* The hidden field the form itself would post is the floor under
       everything below. It is read FIRST and parked on ctx, so a page whose
       variant JSON is missing, malformed, or sitting outside [data-sts-product]
       still knows which variant Add to cart adds. Before this, any of those
       left ctx.variant null and the add threw on `.id` with the submit already
       default-prevented: a button that did nothing at all. */
    var input = qs(root, '[data-sts-variant-input]');
    if (input && input.value) {
      ctx.variant = { id: input.value, available: true, planId: null, planPct: null };
    }

    var variants = jsonFrom(root, '[data-sts-variants]') || [];
    if (!variants.length) return;
    root.stsVs = variants;

    var chips = qsa(root, '[data-sts-variant-chip]');
    var vbtn = qs(root, '[data-sts-sticky-var-btn]');
    var vlist = qs(root, '[data-sts-sticky-vars]');
    var opts = qsa(root, '[data-sts-sticky-opt]');

    function find(id) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(id)) return variants[i];
      }
      return variants[0];
    }

    function apply(v) {
      ctx.variant = v;
      root.stsV = v;
      if (input) input.value = v.id;

      text(qs(root, '[data-sts-price]'), v.priceText);
      show(qs(root, '[data-sts-compare]'), v.onSale);
      text(qs(root, '[data-sts-compare]'), v.compareText);
      var save = qs(root, '[data-sts-save]');
      if (save) { save.hidden = !v.onSale; save.textContent = 'Save ' + v.saveText; }
      var size = qs(root, '[data-sts-size]');
      if (size) { size.hidden = !v.title || v.title === 'Default Title'; size.textContent = v.title; }
      var unit = qs(root, '[data-sts-unit]');
      if (unit) { unit.hidden = !v.unitText; unit.textContent = v.unitText; }
      show(qs(root, '[data-sts-sale-pill]'), v.onSale);
      /* The media column carries the verdict too. See snippets/sts-pdp-gallery. */
      show(qs(root, '[data-sts-soldout-pill]'), !v.available);
      show(qs(root, '[data-sts-qty-line]'), v.available);
      text(qs(root, '[data-sts-sticky-price]'), v.priceText);
      /* Skin Type Cash per size (snippets/sts-cash-amount.liquid); "" = none. */
      qsa(root, '[data-sts-cash-amt]').forEach(function (el) { el.textContent = v.cashText || ''; });
      qsa(root, '[data-sts-cash-line],[data-sts-sticky-cash]').forEach(function (el) { el.hidden = !v.cashText || !!root.stsCashOff; });

      /* Subscribe needs a plan AND stock: docs/new-theme-v4/asset-notes/sts-product-js.md. */
      var plans = qs(root, '[data-sts-plans]');
      if (plans) {
        var canSub = !!v.planId && v.available;
        plans.hidden = !canSub;
        var sub = qs(root, '[data-sts-plan-sub]');
        if (sub) { sub.value = canSub ? String(v.planId) : ''; sub.disabled = !canSub; }
        if (!canSub) text(qs(root, '[data-sts-sub-line]'), 'Subscribe & save');
        fillFreq(root, canSub ? (v.plans || []) : []);
        syncPlan(root);
      }

      qsa(root, '[data-sts-add],[data-sts-buy-anyway],[data-sts-sticky-add],[data-sts-sticky-anyway]')
        .forEach(function (btn) { btn.disabled = !v.available; });
      if (!v.available) {
        text(qs(root, '[data-sts-add-label]'), 'Sold out');
        text(qs(root, '[data-sts-sticky-label]'), 'Sold out');
      } else {
        text(qs(root, '[data-sts-add-label]'), ctx.addLabel);
        text(qs(root, '[data-sts-sticky-label]'), ctx.stickyLabel);
      }
      /* The server prints "Sold out" or "Add to cart anyway" for the size it
         landed on; follow the size picked since. */
      qsa(root, '[data-sts-anyway-label]').forEach(function (el) { text(el, v.available ? 'Add to cart anyway' : 'Sold out'); });
      /* After the labels: the fit is measured on the words the buttons now carry. */
      paintKind(root, v);

      chips.forEach(function (chip) {
        chip.setAttribute('aria-pressed', String(chip.getAttribute('data-sts-variant-chip') === String(v.id)));
      });
      /* The floating bar's bubble (v6.1 §5.1) follows the same choice. */
      text(qs(root, '[data-sts-sticky-var-label]'), v.title);
      if (vbtn) vbtn.setAttribute('aria-label', (vbtn.getAttribute('data-label-pre') || '') + v.title);
      opts.forEach(function (o) {
        o.setAttribute('aria-selected', String(o.getAttribute('data-sts-sticky-opt') === String(v.id)));
      });

      var slides = qs(root, '[data-sts-gallery-slides]');
      if (slides && slides.children[v.mediaIndex]) {
        slides.scrollTo({ left: slides.children[v.mediaIndex].offsetLeft, behavior: scrollBehavior() });
      }

      /* Keep the address bar honest so a copied link reopens this variant. */
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      /* Add to my routine repaints for the exact variant (assets/sts-add-routine.js). */
      try { document.dispatchEvent(new CustomEvent('sts:pdp:variant', { detail: { id: v.id } })); } catch (e) { /* old engine */ }
    }

    chips.forEach(function (chip) {
      on(chip, 'click', function () { apply(find(chip.getAttribute('data-sts-variant-chip'))); });
    });
    /* A size tapped before this script ran (slow phone): the inline listener in
       snippets/sts-pdp-buybox.liquid already put it in the form. Paint it now.
       Exact match only: find()'s first-variant fallback must never replace a
       real pick with the wrong size. */
    var picked = input && input.getAttribute('data-sts-picked');
    if (picked) {
      input.removeAttribute('data-sts-picked');
      variants.forEach(function (v) { if (String(v.id) === String(picked)) apply(v); });
    }

    /* v6.1 §5.1: the bubble's list is a listbox of buttons; picking one is a
       chip click. Arrows move, Escape closes back onto the bubble, and a click
       or focus outside closes it. initSticky() closes it with the bar. */
    function varOpen(open, refocus) {
      if (!vbtn || !vlist) return;
      vlist.hidden = !open;
      vbtn.setAttribute('aria-expanded', String(open));
      if (open) { var sel = qs(vlist, '[aria-selected="true"]') || opts[0]; if (sel) sel.focus(); } else if (refocus) vbtn.focus();
    }
    var bar = qs(root, '[data-sts-sticky]');
    if (bar) bar.stsVarClose = function () { varOpen(false); };
    on(vbtn, 'click', function () { varOpen(!!vlist && vlist.hidden); });
    on(vbtn, 'keydown', function (ev) { if (ev.key === 'Escape') varOpen(false); });
    opts.forEach(function (o, i) {
      on(o, 'click', function () { apply(find(o.getAttribute('data-sts-sticky-opt'))); varOpen(false, true); });
      on(o, 'keydown', function (ev) {
        var k = ev.key;
        if (k === 'Escape') { ev.preventDefault(); varOpen(false, true); return; }
        var n = k === 'ArrowDown' ? i + 1 : k === 'ArrowUp' ? i - 1 : k === 'Home' ? 0 : k === 'End' ? opts.length - 1 : null;
        if (n === null) return;
        ev.preventDefault();
        opts[(n + opts.length) % opts.length].focus();
      });
    });
    on(vlist, 'focusout', function (ev) {
      var to = ev.relatedTarget;
      if (to && to !== vbtn && !vlist.contains(to)) varOpen(false);
    });
    on(document, 'click', function (ev) {
      if (vlist && !vlist.hidden && !vbtn.contains(ev.target) && !vlist.contains(ev.target)) varOpen(false);
    });

    ctx.variant = root.stsV = find(input ? input.value : variants[0].id);
  }

  // ------------------------------------------------ Add to cart's purchase type

  /* 2026-10-20: a shopper could not find how to buy once on a page that also
     offers Subscribe & save. While the Subscribe button is live, every one-time
     add button (buy box, Add to cart anyway, sticky bar) reads
     "Add to cart · One-time purchase · $90" (snippets/sts-pdp-atc-kind). No
     live plan, or sold out: the tail is hidden and the label is as before. */
  function paintKind(root, v) {
    var canSub = !!qs(root, '[data-sts-plans]') && !!v && !!v.planId && !!v.available;
    qsa(root, '[data-sts-atc-kind]').forEach(function (el) { el.hidden = !canSub; });
    if (v && v.priceText) qsa(root, '[data-sts-atc-price]').forEach(function (el) { el.textContent = v.priceText; });
    fitAtc(root);
  }

  /* One line: the long wording, else "One-time", else no word and just the
     price ("bare"), else no tail at all ("plain": the phone sticky bar beside
     Add to routine, whose price sits just above it), else it wraps. "Add to cart only" (a typed shopper, Add
     to my routine above it) skips "One-time": "only" already says it, and
     "Add to cart only · One-time · $45" is what crowded a phone. Measured, not
     a breakpoint, because the room depends on the price, the column and the
     sticky bar's second button. It is measured with the product's longest
     price in place (atcProbe), so switching sizes never flips the wording.
     A button with no width yet is skipped; the ResizeObserver in initAtc()
     measures it once it has one. */
  function fitOne(btn, probe) {
    var txt = qs(btn, '.sts-atc__txt');
    if (!txt || !btn.clientWidth) return;
    var cs = window.getComputedStyle(btn);
    var pad = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0);
    var price = qs(btn, '[data-sts-atc-price]');
    var shown = price && price.textContent;
    if (price && probe) price.textContent = probe;
    var mode = 'wrap';
    var only = qs(btn, '.sts-rt-only');
    var modes = only && only.getClientRects().length ? ['long', 'bare', 'plain'] : ['long', 'short', 'bare', 'plain'];
    for (var i = 0; i < modes.length; i++) {
      btn.setAttribute('data-sts-fit', modes[i]);
      /* Room is read per wording: the desktop sticky button sizes to its label. */
      if (txt.getBoundingClientRect().width <= btn.clientWidth - pad + 0.5) { mode = modes[i]; break; }
    }
    if (price && probe) price.textContent = shown;
    btn.setAttribute('data-sts-fit', mode);
  }

  function atcProbe(root) {
    var probe = '';
    (root.stsVs || []).forEach(function (v) { if (v.priceText && v.priceText.length > probe.length) probe = v.priceText; });
    /* Same length is not same width ("$19" is narrower than "$38"): measure
       with every digit at its widest. */
    return probe.replace(/[0-9]/g, '8');
  }

  function fitAtc(root) {
    var probe = atcProbe(root);
    qsa(root, '[data-sts-atc]').forEach(function (b) { fitOne(b, probe); });
  }

  function initAtc(root) {
    if (root.stsV) paintKind(root, root.stsV); else fitAtc(root);
    var btns = qsa(root, '[data-sts-atc]');
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function (entries) {
        entries.forEach(function (e) {
          var w = Math.round(e.contentRect.width);
          if (e.target.stsFitW === w) return;
          e.target.stsFitW = w;
          fitOne(e.target, atcProbe(root));
        });
      });
      btns.forEach(function (b) { ro.observe(b); });
    } else {
      on(window, 'resize', function () { fitAtc(root); });
    }
    /* The webfont is wider than the fallback it was first measured in. */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { fitAtc(root); });
    /* A type that lands after the first paint shows or hides " only". */
    on(document, 'sts:state', function () { fitAtc(root); });
  }

  // ---------------------------------------------------------------- quantity

  function initQuantity(root) {
    var input = qs(root, '[data-sts-qty-input]');
    if (!input) return;
    qsa(root, '[data-sts-qty]').forEach(function (btn) {
      on(btn, 'click', function () {
        var next = (parseInt(input.value, 10) || 1) + parseInt(btn.getAttribute('data-sts-qty'), 10);
        input.value = String(Math.max(1, next));
      });
    });
  }

  // ------------------------------------------------------------------ gallery

  function initGallery(root) {
    var slides = qs(root, '[data-sts-gallery-slides]');
    if (!slides) return;
    var thumbs = qsa(root, '[data-sts-thumb]');
    thumbs.forEach(function (thumb) {
      on(thumb, 'click', function () {
        var index = parseInt(thumb.getAttribute('data-sts-thumb'), 10);
        var slide = slides.children[index];
        if (slide) slides.scrollTo({ left: slide.offsetLeft, behavior: scrollBehavior() });
      });
    });
    on(slides, 'scroll', function () {
      var index = Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth));
      thumbs.forEach(function (thumb, i) { thumb.setAttribute('aria-current', String(i === index)); });
    });
  }

  // -------------------------------------------------------------- accordions

  /* <details name=…> already does one-open-at-a-time in current browsers. This
     is the fallback for the ones that ignore the attribute, and it is why the
     markup is <details>/<summary> and not buttons: the copy stays in the DOM for
     a crawler and for a reader with JavaScript off (criterion 46). */
  function initAccordions(root) {
    qsa(root, '[data-sts-accordions]').forEach(function (group) {
      var items = qsa(group, 'details');
      items.forEach(function (item) {
        on(item, 'toggle', function () {
          if (!item.open) return;
          items.forEach(function (other) { if (other !== item) other.open = false; });
        });
      });
    });
  }

  function initFaqs(root) {
    qsa(root, '.sts-faq__q').forEach(function (button) {
      on(button, 'click', function () {
        var open = button.getAttribute('aria-expanded') === 'true';
        var panel = document.getElementById(button.getAttribute('aria-controls'));
        button.setAttribute('aria-expanded', String(!open));
        if (panel) panel.hidden = open;
      });
    });
  }

  // -------------------------------------------------------------- sticky bar

  /* Shown the moment the real buy box leaves the viewport, hidden while it is on
     screen, at every breakpoint — so it can never cover the primary action
     (criterion 44). An observer, not a scroll handler: no work per frame. */
  function initSticky(root) {
    /* The `||` and `inert`: asset note, "initSticky comments". */
    var bar = qs(root, '[data-sts-sticky]') || qs(document, '[data-sts-sticky]');
    var box = qs(root, '[data-sts-buybox]');
    if (!bar || !box) return;
    /* v6 §6.5: on a phone the ▾ tab folds the bar into the ▴ Add to cart pill
       (with its ↑) and the pill unfolds it. One state, `want` (the observer)
       and `min` (the shopper), decides both, so the bar and the pill can never
       be on screen together. Folding is phone-only: at 861px and up the tab
       and pill are not drawn, so `min` is ignored there. Focus follows the
       control that replaced the one just pressed. */
    var pill = qs(root, '[data-sts-sticky-min]') || qs(document, '[data-sts-sticky-min]');
    var phone = window.matchMedia ? window.matchMedia('(max-width: 860px)') : null;
    var want = false;
    var min = false;
    function render() {
      var folded = min && !!phone && phone.matches;
      var shown = want && !folded;
      bar.setAttribute('data-shown', String(shown));
      bar.setAttribute('aria-hidden', String(!shown));
      if ('inert' in HTMLElement.prototype) bar.inert = !shown;
      if (pill) pill.hidden = !(want && folded);
      if (!shown && bar.stsVarClose) bar.stsVarClose();
    }
    /* v6.1 §5: back above the main button clears the ▾ fold, so the bar opens
       again the next time it appears. The fold is never saved. */
    function setShown(shown) { want = shown; if (!shown) min = false; render(); }
    function fold(to, focusSel) {
      min = to;
      render();
      var f = qs(to ? pill : bar, focusSel);
      if (!f) return;
      f.focus();
      /* Reduced motion forces a .001ms transition on everything (sts-tokens.css),
         so the bar can still be hidden for this tick: try again next frame. */
      if (document.activeElement !== f) window.requestAnimationFrame(function () { f.focus(); });
    }
    on(qs(bar, '[data-sts-sticky-hide]'), 'click', function () { fold(true, '[data-sts-sticky-show]'); });
    on(pill && qs(pill, '[data-sts-sticky-show]'), 'click', function () { fold(false, '[data-sts-sticky-hide]'); });
    if (phone) on(phone, 'change', render);
    /* The bar's real height, for the page's bottom reservation and the toast
       (assets/sts-product.css, --sts-sticky-h): one line or two, a second
       button or not. */
    if ('ResizeObserver' in window) {
      new ResizeObserver(function () {
        if (bar.offsetHeight) document.documentElement.style.setProperty('--sts-sticky-h', bar.offsetHeight + 'px');
      }).observe(bar);
    }
    if (!('IntersectionObserver' in window)) {
      setShown(true);
      return;
    }
    /* Shown only once the main button has scrolled ABOVE the viewport; one
       still below the fold does not count (asset note, "initSticky"). */
    var btns = qsa(box, '[data-sts-add],[data-sts-buy-anyway]');
    if (!btns.length) btns = [box];
    function check() {
      var shown = false;
      btns.forEach(function (b) { if (b.offsetParent && b.getBoundingClientRect().bottom < 0) shown = true; });
      setShown(shown);
    }
    var io = new IntersectionObserver(check);
    btns.forEach(function (b) { io.observe(b); });
    /* A jump from below the fold to above it (anchor, restored scroll) never
       crosses the viewport, so the observer never fires: re-check then too. */
    ['load', 'pageshow', 'hashchange', 'scrollend'].forEach(function (e) { on(window, e, check); });
    check();
  }

  /* Add to my routine (v6 6.2 / 6.3, PDP-1) lives in assets/sts-add-routine.js:
     it owns the routine button, the Replace popup and the confirmation card.
     Add to cart here is always a plain cart add (decision a). */

  // --------------------------------------------------------------- buy button

  /* `_sts_src` (spec 09 §3.7) names the surface the line came from. `buy_anyway`
     and `routine_add` are the spec's own values; the plain button, the sticky
     bar and the subscribe button name themselves, the way the collection quick
     add names itself `collection_quick_add`. */
  function sourceFor(ctx, options) {
    if (options.barred) return 'buy_anyway';
    if (options.sticky) return 'pdp_sticky';
    if (options.sellingPlan) return 'pdp_subscribe';
    return 'pdp';
  }

  /* The Subscribe button's value is the plan (asset note, "Subscribe button").
     Add to cart never reads it: that path is always one-time. */
  function selectedPlan(root) {
    var el = qs(root, '[data-sts-plan-sub]');
    return (el && !el.disabled && el.value) || null;
  }

  function syncPlan(root) {
    var sub = qs(root, '[data-sts-plan-sub]');
    var v = root.stsV;
    if (!sub || sub.disabled) return;
    var r = qs(root, '[data-sts-freq-radio]:checked');
    if (r) sub.value = r.value;
    if (!v) return;
    var p = null;
    (v.plans || []).forEach(function (x) { if (String(x.id) === sub.value) p = x; });
    root.stsCad = { id: sub.value, every: p ? (p.every || p.label) : '' };
    var pct = p && p.pct != null ? p.pct : v.planPct;
    text(qs(root, '[data-sts-sub-line]'), 'Subscribe & save ' + pct + '% \u00b7 ' +
      ((p && p.price) || v.planPriceText) + ' per refill');
  }

  function fillFreq(root, plans) {
    var box = qs(root, '[data-sts-freq]');
    if (!box) return;
    var many = plans.length > 1;
    box.innerHTML = '';
    box.hidden = !(many || (plans.length === 1 && (plans[0].every || plans[0].label)));
    if (box.hidden) return;
    function el(tag, cls) { var n = document.createElement(tag); n.className = cls; return n; }
    if (!many) {
      var one = el('p', 'sts-cad__one');
      one.textContent = plans[0].every ? 'Ships every ' + plans[0].every : plans[0].label;
      box.appendChild(one);
      return;
    }
    /* Keep the shopper's cadence across a size change: same plan id, else the
       same interval, else the first (asset note, "cadence kept"). Until they
       pick one, the size's own default `defPlan` (sections/sts-main-product):
       its 30-day plan when it has one (Luis, 2026-10-13), else the plan
       nearest its days of supply (v6.1 §6, snippets/sts-supply-days.liquid). */
    var want = root.stsCadPicked ? (root.stsCad || {}) : { id: String((root.stsV && root.stsV.defPlan) || '') };
    var pick = 0;
    plans.forEach(function (p, i) { if (String(p.id) === want.id) pick = i; });
    if (String(plans[pick].id) !== want.id) {
      plans.forEach(function (p, i) { if (want.every && (p.every || p.label) === want.every) pick = i; });
    }
    var fs = el('fieldset', 'sts-cad');
    var lg = el('legend', 'sts-cad__label');
    lg.textContent = 'Ships every';
    fs.appendChild(lg);
    plans.forEach(function (p, i) {
      var lab = el('label', 'sts-cad__chip');
      var inp = el('input', 'sts-cad__input');
      inp.type = 'radio';
      inp.name = box.getAttribute('data-sts-freq') || 'sts-freq';
      inp.value = String(p.id);
      inp.checked = i === pick;
      inp.setAttribute('data-sts-freq-radio', '');
      var t = document.createElement('span');
      t.textContent = p.every || p.label;
      lab.appendChild(inp);
      lab.appendChild(t);
      fs.appendChild(lab);
    });
    box.appendChild(fs);
  }

  function lineProperties(root, ctx) {
    var props = { _sts_src: ctx.src };
    if (ctx.barred) props._sts_not_for_type = shopperType() || '';
    return props;
  }

  function quantity(root) {
    var input = qs(root, '[data-sts-qty-input]');
    return Math.max(1, parseInt(input && input.value, 10) || 1);
  }

  /* The id this button adds. ctx.variant is the full variant record when the
     page handed the script one; the hidden field is the same id the form posts
     on its own and is read again here, so nothing on the add path depends on
     that record having been built. Null means the buy box carries no variant at
     all — a page with nothing to sell — which is said, never thrown. */
  function variantId(root, ctx) {
    if (ctx.variant && ctx.variant.id) return ctx.variant.id;
    var input = qs(root, '[data-sts-variant-input]');
    return (input && input.value) || null;
  }

  function addCurrent(root, ctx, opts) {
    var options = opts || {};
    var id = variantId(root, ctx);
    if (!id) {
      notice('We could not add that to your cart', 'Try again in a moment.');
      return Promise.resolve(null);
    }
    var item = { id: id, quantity: quantity(root) };
    item.properties = lineProperties(root, {
      barred: options.barred,
      src: sourceFor({}, options)
    });
    if (options.sellingPlan) item.selling_plan = options.sellingPlan;

    var buttons = qsa(root, '[data-sts-add],[data-sts-buy-anyway],[data-sts-plan-sub],[data-sts-sticky-add],[data-sts-sticky-anyway]');
    buttons.forEach(function (b) { b.setAttribute('data-busy', 'true'); });

    /* #1054: a subscribed line carries `_sts_origin`, "routine" when this
       product is in the shopper's routine (STS.addRoutine, on this page),
       "also" otherwise. */
    var R = window.STS && window.STS.addRoutine;
    var tagged = !options.sellingPlan ? Promise.resolve() : (R ? R.get() : Promise.resolve())
      .then(function () {
        return R && R.inRoutine({ variants: [String(id)], handle: root.getAttribute('data-handle') });
      }, function () { return false; })
      .then(function (inR) { item.properties._sts_origin = inR ? 'routine' : 'also'; });

    return tagged.then(function () { return cartAdd([item]); })
      .then(function () { return announceCart(); })
      /* Shopify's own reason, or a plain line; never the raw exception
         ("Failed to fetch" offline). STS.shopperError, snippets/sts-error-js. */
      .catch(function (err) { var f = (window.STS || {}).shopperError; notice('We could not add that to your cart', f ? f(err) : 'Try again in a moment.'); })
      .then(function () { buttons.forEach(function (b) { b.removeAttribute('data-busy'); }); });
  }

  /* v6.3 §3: every cart add below asks first when the size is the smaller
     one, and adds nothing until OK (assets/sts-small-size.js). Add to my
     routine never comes through here (decision 1). */
  function smallFirst(root, ctx, go) {
    var S = window.STS && window.STS.smallSize;
    if (S) S.guard(root, variantId(root, ctx), go); else go();
  }

  function initBuy(root, ctx) {
    var form = qs(root, '.sts-buy__form');
    var subBtn = qs(root, '[data-sts-plan-sub]');
    var subClick = false;
    on(subBtn, 'click', function () { subClick = true; });
    if (form) {
      on(form, 'submit', function (ev) {
        ev.preventDefault();
        /* Which button submitted decides the purchase: Add to cart is always
           one-time, Subscribe carries its plan. If the AJAX add throws, the
           submit is handed back with the hidden selling_plan field set to match,
           never swallowed (asset note, "initBuy"). */
        var isSub = ev.submitter ? ev.submitter === subBtn : subClick;
        subClick = false;
        var plan = isSub ? selectedPlan(root) : null;
        if (isSub && !plan) return;
        smallFirst(root, ctx, function () { try {
          if (plan) {
            /* §6.9 event 16, with the pct of the plan actually chosen. */
            var pv = null;
            ((ctx.variant && ctx.variant.plans) || []).forEach(function (x) { if (String(x.id) === plan) pv = x; });
            track('sts_subscribe_select', {
              surface: 'pdp',
              on: true,
              discount_pct: pv && pv.pct != null ? pv.pct : (ctx.variant ? ctx.variant.planPct : null),
              product_id: root.getAttribute('data-product-id')
            });
            var anyway = qs(root, '[data-sts-buy-anyway]');
            if (anyway && anyway.offsetParent) { buyAnyway('pdp_fit_box', plan); return; }
          }
          addCurrent(root, ctx, { sellingPlan: plan });
        } catch (e) {
          var field = qs(root, '[data-sts-plan-input]');
          if (field) { field.value = plan || ''; field.disabled = !plan; }
          form.submit();
        } });
      });
    }

    /* Delegated: fillFreq() rebuilds the chips on every variant change. */
    on(qs(root, '[data-sts-freq]'), 'change', function (ev) {
      if (ev.target && ev.target.hasAttribute && ev.target.hasAttribute('data-sts-freq-radio')) { root.stsCadPicked = true; syncPlan(root); }
    });
    syncPlan(root);

    on(qs(root, '[data-sts-sticky-add]'), 'click', function () {
      /* §6.9 event 15. The label is whatever the bar says at the moment of the
         tap — Add to cart, Add to routine or Sold out. */
      track('sts_sticky_atc_click', {
        product_id: root.getAttribute('data-product-id'),
        label: (qs(root, '[data-sts-sticky-label]') || {}).textContent || null
      });
      smallFirst(root, ctx, function () { addCurrent(root, ctx, { sticky: true }); });
    });

    /* Nothing is ever blocked (04-Q31). The confirm exists so the choice is
       deliberate, and the line carries _sts_not_for_type so workstream 06 can
       see it on the order; the underscore keeps it out of cart and checkout. */
    function buyAnyway(surface, plan) {
      /* §6.9 event 13: shown, then confirm or dismiss. `letter` is the barred
         letter, never the type; the ad gate drops both anyway. */
      function prompted(action) {
        track('sts_buy_anyway_prompt', {
          action: action,
          surface: surface,
          letter: root.getAttribute('data-sts-bar'),
          product_id: root.getAttribute('data-product-id')
        });
      }
      prompted('shown');
      /* A sensitivity-subtype miss is not a type bar: its own title, and its
         own line as the reason (asset note, "subtype headline"). */
      var subMiss = root.getAttribute('data-sts-subtype') === 'miss';
      var why = ((subMiss ? qs(root, '[data-sts-subtype-reason]') : qs(root, '[data-sts-reason]')) || {}).textContent || '';
      why = why.trim();
      confirmDialog({
        title: subMiss ? 'Not recommended for your sensitivity' : 'Not for your skin type',
        /* v6.2 §11: Dr. Baumann's reason and nothing after it. */
        body: why || 'Dr. Baumann has not approved this product for your Baumann Skin Type.',
        yes: 'Add to cart anyway',
        no: 'No thanks'
      }).then(function (confirmed) {
        prompted(confirmed ? 'confirm' : 'dismiss');
        if (confirmed) addCurrent(root, ctx, { barred: true, sticky: surface === 'pdp_sticky', sellingPlan: plan || null });
      });
    }
    on(qs(root, '[data-sts-buy-anyway]'), 'click', function () { smallFirst(root, ctx, function () { buyAnyway('pdp_fit_box'); }); });
    on(qs(root, '[data-sts-sticky-anyway]'), 'click', function () { smallFirst(root, ctx, function () { buyAnyway('pdp_sticky'); }); });

  }

  // ------------------------------------------------------------ the cross-sell

  /* The row comes back as rendered Liquid from this section's own
     `recommendations` branch, so every tile arrives with its approval
     attributes. The JSON recommendations endpoint carries no metafields, which
     is why it is not used: a row built from it could not tell whether a product
     is wrong for the shopper and would contradict the fit box above it. */
  function fetchRow(root, grid, slot) {
    var sectionId = root.getAttribute('data-section-id');
    var productId = root.getAttribute('data-product-id');
    var url = '/recommendations/products?section_id=' + encodeURIComponent(sectionId) +
      '&product_id=' + encodeURIComponent(productId) +
      '&intent=' + encodeURIComponent(grid.getAttribute('data-intent')) +
      '&limit=' + encodeURIComponent(grid.getAttribute('data-limit') || '4');
    return netFetch(url)
      .then(function (r) {
        if (!r.ok) throw r.status;
        return r.text();
      })
      .then(function (html) {
        if (!html.trim()) throw new Error('empty section');
        /* Shopify wraps a section-rendering response in
           <div id="shopify-section-…">. Lifting just the tiles out keeps the
           grid's own columns and means no markup from the response is ever
           inserted as raw HTML. */
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var tiles = parsed.querySelectorAll('[data-sts-tile]');
        if (!tiles.length) throw new Error('no tiles');
        for (var i = 0; i < tiles.length; i++) {
          grid.appendChild(document.importNode(tiles[i], true));
        }
        return true;
      })
      .catch(function (err) {
        /* §6.9 event 35. Without it a row that never rendered reads as a row
           nobody engaged with. */
        track('sts_slot_failed', { slot: slot, reason: failReason(err) });
        return false;
      });
  }

  /* Server-side Liquid already marks a tile barred for a SIGNED-IN customer.
     For a typed shopper who is not signed in the verdict is "unknown" in Liquid,
     so it is resolved here from the tile's own approval list — the same data,
     the same answer, one frame later (criteria 50 and 53). A tile missing one
     of the shopper's sensitivity subtypes goes too: sensitivity is filtered as
     strongly as type (Robert, 6.3.2 note 03). */
  function dropBarredTiles(root, grid) {
    var type = shopperType();
    if (!type) return;
    var wanted = shopperSubtypes();
    qsa(grid, '[data-sts-tile]').forEach(function (tile) {
      var approved = (tile.getAttribute('data-sts-approved') || '').split(' ').filter(Boolean);
      if (!approved.length) return;
      var sens = (tile.getAttribute('data-sts-sens') || '').split(' ').filter(Boolean);
      var missing = wanted.some(function (c) { return sens.indexOf(c) < 0; });
      if (approved.indexOf(type) < 0 || missing) tile.remove();
    });
  }

  function initCrossSell(root) {
    var section = qs(document, '[data-sts-cross]');
    var grid = section && qs(section, '[data-sts-cross-grid]');
    if (!grid) return;
    fetchRow(root, grid, 'pdp_cross_sell').then(function (loaded) {
      if (loaded) dropBarredTiles(root, grid);
      /* Liquid's own barred tiles (signed in) are display:none; out, so the
         pages count only what shows. */
      qsa(grid, '[data-sts-fit="barred"],[data-sts-fit="subtype"]').forEach(function (tile) { tile.remove(); });
      var tiles = qsa(grid, '[data-sts-tile]');
      if (!tiles.length) { section.hidden = true; return; }
      crossPager(section, grid, tiles.length);
      var type = shopperType();
      if (type) text(qs(section, '[data-sts-cross-heading]'), 'More for skin type ' + type);
    });
  }

  /* Max, 2026-10-06: up to 10, a page (2 on a phone, 4 from 750px) at a
     time: ‹ › scroll one page, a swipe works too, "1-4 of 10" follows. */
  function crossPager(section, grid, n) {
    var nav = qs(section, '[data-sts-cross-nav]');
    var prev = qs(section, '[data-sts-cross-prev]'), next = qs(section, '[data-sts-cross-next]');
    var range = qs(section, '[data-sts-cross-range]');
    if (!nav || !prev || !next) return;
    function per() { return window.matchMedia('(min-width: 750px)').matches ? 4 : 2; }
    function step() { var t = grid.firstElementChild; return (t ? t.getBoundingClientRect().width + (parseFloat(getComputedStyle(grid).columnGap) || 0) : 0) || 1; }
    function paint() {
      var p = per(), paged = n > p;
      grid.toggleAttribute('data-sts-paged', paged);
      nav.hidden = !paged;
      if (!paged) return;
      var first = Math.min(n - 1, Math.round(grid.scrollLeft / step()));
      var last = Math.min(n, first + p);
      prev.disabled = first <= 0;
      next.disabled = last >= n;
      text(range, (first + 1) + '–' + last + ' of ' + n);
    }
    function go(dir) {
      var smooth = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      grid.scrollBy({ left: dir * step() * per(), behavior: smooth ? 'smooth' : 'auto' });
    }
    on(prev, 'click', function () { go(-1); });
    on(next, 'click', function () { go(1); });
    var raf = 0;
    function later() { if (!raf) raf = window.requestAnimationFrame(function () { raf = 0; paint(); }); }
    grid.addEventListener('scroll', later, { passive: true });
    window.addEventListener('resize', later);
    paint();
  }

  // --------------------------------------------------------------------- boot

  function init(root) {
    if (root.__stsInit) return;
    root.__stsInit = true;

    var ctx = {
      variant: null,
      addLabel: 'Add to cart',
      stickyLabel: 'Add to cart'
    };

    /* One initializer that throws must not take the rest down with it. */
    function run(fn) {
      try { fn(root, ctx); } catch (e) { if (window.console) console.error('[sts-product]', fn.name, e); }
    }
    run(resolveFit);
    run(emitFitView);
    if (window.STS && typeof window.STS.onState === 'function') window.STS.onState(function () { resolveFit(root); });
    [applyCashSuppression, initVariants, initAtc, initQuantity, initGallery, initAccordions, initFaqs,
      initSticky, initBuy, initQuizLinks, initReviewsLink].forEach(run);

    /* The cross-sell row is below the fold on every viewport, so it waits until
       it is nearly on screen. On a browser without IntersectionObserver it loads
       at boot, which is the old behaviour and still correct. */
    var rows = function () { initCrossSell(root); };
    var anchor = qs(document, '[data-sts-cross]');
    if (anchor && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries, self) {
        if (!entries[0].isIntersecting) return;
        self.disconnect();
        rows();
      }, { rootMargin: '600px 0px' });
      observer.observe(anchor);
    } else {
      rows();
    }
  }

  function boot() {
    qsa(document, '[data-sts-product]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  /* Theme editor: a section re-render replaces the root, so re-run on it. */
  document.addEventListener('shopify:section:load', function (ev) {
    qsa(ev.target, '[data-sts-product]').forEach(init);
  });
}());
